import { SiteBudgetForm } from '../types/site-budget-form.type';

export const EDITABLE_SITE_BUDGET_FORM_FIELDS: (keyof SiteBudgetForm)[] = [
  'costType',
  'patientGroup',
  'protocolVersion',
  'siteBudgetVersion',
];
